<template>
  <div>
    <!-- <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="systemTag">
          <el-breadcrumb-item :to="{ path: 'dashboard' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>工作广场</el-breadcrumb-item>
          <el-breadcrumb-item v-if="navState == 1">添加岗位</el-breadcrumb-item>
          <el-breadcrumb-item v-if="navState == 2">选择门店</el-breadcrumb-item>
        </el-breadcrumb>
    </div> -->
    <div class="systemNav">
      <div class="systemNavWrap">
        <div @click="navState = 1"
             :class="{'isActive': navState == 1 && !isModify,'modifyIsActive': navState >= 1 && isModify == true}">
          <span><img :src="iconList.iconaddjobs" alt=""/>添加岗位</span>
        </div>
        <i v-if="isModify" class="el-icon-arrow-right" :class="{'changeColor': isModify == true && navState > 1}"></i>
        <div @click="checkTabStore" :class="{'isActive' : navState == 2 && !isModify,'modifyIsActive': navState >= 2 && isModify == true}">
          <span><img :src="iconList.iconselectstore" alt=""/>选择门店</span>
        </div>
        <i class="el-icon-arrow-right" :class="{'changeColor': isModify == true && navState > 2}" v-if="isModify"></i>
      </div>
    </div>
    <div>
      <AddWorks ref="addWorks" v-if="navState == 1" @check-store="checkStore" @resetThis="resetAddWorks"/>
      <ChooseStore v-if="navState == 2" :jobInformation="jobInformation" @ReceiveState="receiveState" :proDuringTime="proDuringTime"/>
    </div>
    <!-- <el-row style="margin-bottom: 15px;">
        <div class="btns">
          <el-button type="text" @click="cancelCheckStore">取消</el-button>
          <el-button type="primary" class="sureBtn" @click="checkStore">选择门店</el-button>
        </div>
      </el-row> -->
  </div>
</template>

<script>
  //这个页面暂时不加权限控制，否则江一没法调用了
  import {mapMutations} from "vuex";
  import AddWorks from './addWorks.vue'
  import ChooseStore from './chooseStore.vue'

  export default {
    name: 'postJob',
    data() {
      return {
        navState: 1,
        isModify: false,
        iconList: {
          iconaddjobs: require('../../../common/images/icon-tixipeizhiActive.png'),
          iconselectstore: require('../../../common/images/icon-jifen.png'),
        },
        jobInformation: {},
        proDuringTime: {},//本应放在jobInfo中的，怕塞进去出问题就单独扯出来，以便控制岗位的时间不能超出项目的时间
      }
    },
    components: {
      AddWorks,
      ChooseStore
    },
    mounted(){
      this.getWorkCode()
    },
    destroyed(){
      //每次销毁前重置，清除vuex中store中第一页的数据、清除已经发布的状态
      this.saveWorkSquareInfo(null)
      this.workSquareIsEditMethods(false)
    },
    methods: {
      ...mapMutations(["saveWorkSquareInfo", "workSquareIsEditMethods"]),
      // 获取岗位唯一识别码，不希望nav切换时重新获取
      getWorkCode() {
        this.$http({
          method: "GET",
          url: '/rest/PublishedWork/searchWorkCode',
        }).then(res => {
          this.$refs.addWorks._data.jobInformation.workCode = res.data.message
        })
      },
      changeIcon() {
        if (!this.isModify) {
          this.iconList.iconaddjobs = require('../../../common/images/icon-tixipeizhi.png')
          this.iconList.iconselectstore = require('../../../common/images/icon-jifen.png')
          if (this.navState == 1) {
            this.iconList.iconaddjobs = require('../../../common/images/icon-tixipeizhiActive.png')
          } else if (this.navState == 2) {
            this.iconList.iconselectstore = require('../../../common/images/icon-jifenActive.png')
          }
        }
      },
      checkValues(jobInformation) {
        let errMag = ''
        if (jobInformation.projectCode == null) {
          errMag = "请选择项目";
        } else if (jobInformation.posName == null || jobInformation.posName == '' || jobInformation.posName == undefined) {
          errMag = "请输入任务名称";
        } else if (jobInformation.jobType == null || jobInformation.jobType == '' || jobInformation.jobType == undefined) {
          errMag = "请选择岗位类型";
        } else if (jobInformation.customer == null || jobInformation.customer == '' || jobInformation.customer == undefined) {
          errMag = "请输入服务对象";
        } else if (jobInformation.dateType == null || jobInformation.dateType == '' || jobInformation.dateType == undefined) {
          errMag = "请选择档期类型";
        } else if (jobInformation.posDetail == null || jobInformation.posDetail == '' || jobInformation.posDetail == undefined) {
          errMag = "请配置任务说明";
        } else if (jobInformation.salaryDetail == null || jobInformation.salaryDetail == '' || jobInformation.salaryDetail == undefined) {
          errMag = "此项目还未配置服务费说明，请联系项目组进行配置";
        } else if (jobInformation.welfareDetail == null || jobInformation.welfareDetail == '' || jobInformation.welfareDetail == undefined) {
          errMag = "请输入岗位福利";
        } else if (jobInformation.requirements == null || jobInformation.requirements == '' || jobInformation.requirements == undefined) {
          errMag = "请配置任务要求";
        } else if (jobInformation.salaryType == null) {
          errMag = "请选择岗位薪水";
        } else if (jobInformation.salaryType == 1 && (jobInformation.daySalary == null || jobInformation.daySalary == '' || jobInformation.daySalary == undefined)) {
          errMag = "请输入岗位薪水";
        } else if (jobInformation.salaryType == 1 && (isNaN(Number(jobInformation.daySalary)))) {
          errMag = "岗位薪水请输入数字类型!";
        } else if (jobInformation.salaryType == 1 && (jobInformation.daySalary != null && jobInformation.daySalary != '' && jobInformation.daySalary != undefined) && (!isNaN(Number(jobInformation.daySalary))) && Number(jobInformation.daySalary) < 0) {
          errMag = "请输入正确岗位薪水";
        } else if (jobInformation.salaryType == 2 && (jobInformation.monthSalary == null || jobInformation.monthSalary == '' || jobInformation.monthSalary == undefined)) {
          errMag = "请输入岗位薪水";
        } else if (jobInformation.salaryType == 2 && (isNaN(Number(jobInformation.monthSalary)))) {
          errMag = "岗位薪水请输入数字类型!";
        } else if (jobInformation.salaryType == 2 && (jobInformation.monthSalary != null && jobInformation.monthSalary != '' && jobInformation.monthSalary != undefined) && (!isNaN(Number(jobInformation.monthSalary))) && Number(jobInformation.monthSalary) < 0) {
          errMag = "请输入正确岗位薪水";
        } else if (jobInformation.salarySettlement == null || jobInformation.salarySettlement == '' || jobInformation.salarySettlement == undefined) {
          errMag = "请选择结算方式";
        } else if (jobInformation.sexName == null || jobInformation.sexName == '' || jobInformation.sexName == undefined) {
          errMag = "请选择性别要求";
        // } else if (jobInformation.moName == null || jobInformation.moName == '' || jobInformation.moName == undefined) {
        //   errMag = "请输入联系人姓名";
        // } else if (jobInformation.moTel == null || jobInformation.moTel == '' || jobInformation.moTel == undefined) {
        //   errMag = "请输入联系人电话！";
        // } else if (isNaN(parseInt(jobInformation.moTel))) {
        //   errMag = '请输入数字类型!'
        // } else if (typeof parseInt(jobInformation.moTel) !== 'number') {
        //   errMag = '请输入数字类型!'
        // } else if (!(/^1[345789]\d{9}$/.test(jobInformation.moTel)) && !(/^0\d{2,3}-\d{7,8}(-\d{1,6})?$/).test(jobInformation.moTel)) {
        //   errMag = '请输入正确的电话号!'
        }/*else if(jobInformation.requirementsTel == null ||jobInformation.requirementsTel == '' || jobInformation.requirementsTel == undefined){
	    		errMag = "请输入联系人方式";
	    	}else if(isNaN(parseInt(jobInformation.requirementsTel))){
	    		errMag = '请输入数字类型!'
	    	}else if(typeof parseInt(jobInformation.requirementsTel) !== 'number'){
	    		errMag = '请输入数字类型!'
	    	}else if(!(/^1[345789]\d{9}$/.test(jobInformation.requirementsTel)) && !(/^0\d{2,3}-\d{7,8}(-\d{1,6})?$/).test(jobInformation.requirementsTel)  ){
	    		errMag = '请输入正确的电话号!'
	    	}*//*else if( (jobInformation.crescoreMin /!*&& jobInformation.crescoreMax*!/) && ( typeof jobInformation.crescoreMin !== 'number' /!*|| typeof jobInformation.crescoreMax !== 'number' *!/) ){
	    		errMag = '信用分值请输入数字类型!'
	    	}*//*else if( (jobInformation.crescoreMin/!* && jobInformation.crescoreMax*!/) /!*&& ( jobInformation.crescoreMin > jobInformation.crescoreMax )*!/){
	    			errMag = '分值区间有误!'
	    	}*//*else if(((jobInformation.crescoreMin != null && jobInformation.crescoreMin != '' && jobInformation.crescoreMin != undefined )/!* && (jobInformation.crescoreMax != null || jobInformation.crescoreMax != '' || jobInformation.crescoreMax != undefined )*!/) && (jobInformation.crescoreMin < 0 /!*|| jobInformation.crescoreMax < 0*!/)){
					errMag = '分值不能为负数!'
				}*/ else if (jobInformation.searchType == null || jobInformation.searchType.length == 0) {

          errMag = '请选择粉丝可见或者会员可见！'
        } else if (jobInformation.posDetail.split(';').includes('其他') && !jobInformation.otherPosDetail) {
          errMag = '请填写任务说明！'
        } else if (jobInformation.requirements.split(';').includes('其他') && !jobInformation.otherRequirements) {
          errMag = '请填写任务要求！'
        }
        if (errMag !== '') {
          this.$notify({
            title: '提示',
            message: errMag,
            type: 'warning'
          });
          return false;
        } else {
          this.navState = jobInformation.navState
        }
      },
      checkStore(jobInformation, proDuringTime) {
        this.jobInformation = jobInformation
        this.proDuringTime = proDuringTime
        this.checkValues(jobInformation)
      },
      receiveState(msg) {
        this.navState = msg
      },
      checkTabStore() {
        this.$children[0].checkStore()
      },
      //重置第一页，先销毁再重新渲染
      resetAddWorks() {
        this.jobInformation = {}
        this.proDuringTime = {}
        this.navState = -99;
        setTimeout(() => {
          this.navState = 1;
        }, 10)
      }
    },
    watch: {
      navState(newValue, oldValue) {
        this.changeIcon()
      }
    },
  }
</script>

<style scoped>
  .systemNav {
    height: 70px;
    /*position: relative;*/
    margin-top: -10px;
  }

  .systemNavWrap {
    padding-top: 20px;
    /*width: 813px;*/
    height: 70px;
    /*margin: 0 auto;*/
  }

  .systemNavWrap div span img {
    vertical-align: text-top;
    margin-right: 5px;
  }

  .systemNavWrap > div {
    width: 150px;
    height: 30px;
    vertical-align: middle;
    text-align: center;
    border: 1px solid transparent;
    border-radius: 20px;
    margin-right: 30px;
    /*margin-left: 30px;*/
    display: inline-block;
    color: #666666;
    font-size: 18px;
    cursor: pointer;
    line-height: 30px;
  }

  .isActive {
    border: 1px solid #2d2c7a !important;
    color: #2d2c7a !important;
    font-weight: bold;
  }

  .changeColor {
    color: #2d2c7a;
    font-weight: bold;
  }

  .modifyIsActive {
    border: 1px solid #2d2c7a !important;
    color: #2d2c7a !important;
    font-weight: bold;
  }

  .el-breadcrumb__item:last-child > .el-breadcrumb__inner {
    color: #8299dc !important;
  }

  .systemTag {
    height: 60px;
    line-height: 60px;
    text-align: right;
    position: absolute;
    /*top: -14px;*/
    right: 20px;
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/workSquare/postJob/postJob.vue